/**
 * Shared settings by all utilities in this package
 */
const config = {
  locale: "en-US",
};

/**
 * Configure the shared settings for the utilities exposed by this package. This
 * function should be called first by the consumer if the sensible defaults need
 * to be tweaked globally.
 * @param configOverrides specify settings and their corresponding values to override
 * @returns the updated configuration object
 */
const configureFormatters = (configOverrides: typeof config) => {
  const newConfig = Object.assign(config, configOverrides);

  return newConfig;
};

export { config, configureFormatters };
